import React, { useEffect } from "react";
import SeccionCard from "../SeccionCard";
import useAutosave from "../useAutosave";

/**
 * Sección de un solo campo de texto largo (enfermedad actual, plan, nota de
 * evolución, motivo). Autoguardado al salir del campo (onBlur) o tras ~1,2 s de
 * inactividad. Mismo endpoint que el botón «Actualizar» de hoy.
 */
export default function SeccionTexto({
  seccionId,
  valor,
  onChangeValor,
  guardar, // (texto) => Promise<{success, data?}>
  onGuardado, // (data) => void  (para adoptar ids nuevos)
  bloqueado, // consulta no abierta / finalizada
  placeholder,
  rows = 8,
  quickChips = [],
  headerExtra,
  onNavegar,
  registrarEstado,
  amberFoot,
  amberMsg,
}) {
  const autosave = useAutosave({
    value: valor || "",
    delay: 1200,
    enabled: !bloqueado,
    save: (texto) => guardar(texto),
    onSaved: onGuardado,
  });

  useEffect(() => {
    registrarEstado(seccionId, autosave);
  }, [seccionId, autosave, registrarEstado]);

  return (
    <SeccionCard
      seccionId={seccionId}
      autosave={autosave}
      headerExtra={headerExtra}
      onNavegar={onNavegar}
      amberFoot={amberFoot}
      amberMsg={amberMsg}
    >
      {quickChips.length > 0 && (
        <div className="cev__qchips">
          {quickChips.map((c) => (
            <button
              key={c}
              type="button"
              className="cev__qc"
              disabled={bloqueado}
              onClick={() => onChangeValor(valor ? `${valor} ${c}` : c)}
            >
              {c}
            </button>
          ))}
        </div>
      )}
      <textarea
        className="form-control"
        rows={rows}
        value={valor || ""}
        placeholder={placeholder}
        disabled={bloqueado}
        onChange={(e) => onChangeValor(e.target.value)}
        onBlur={() => autosave.flush()}
      />
      {bloqueado && (
        <div className="cev__calc-hint">La consulta debe estar abierta («Iniciar consulta») para escribir aquí.</div>
      )}
    </SeccionCard>
  );
}
